import React from "react";
import cx from "clsx";
import { EyeIcon } from "../../../../../../../../../assets/Icons/EyeIcon";
import styles from "./styles.module.scss";

export function Download({ disabled, url }) {
  return (
    <div
      className={cx(styles.root, {
        [styles.disabled]: disabled,
      })}
      title="View"
    >
      {disabled ? (
        <EyeIcon width="18px" />
      ) : (
        <a target="_blank" href={url} rel="noopener noreferrer">
          <EyeIcon width="18px" />
        </a>
      )}
    </div>
  );
}
